import { MAIN_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import { Button } from '@/components/shadcn/button'
import { motion } from 'motion/react'

const HERO_IMAGE = '/assets/photography/PwC_GettyImages_2196870531_MM-web.webp'

function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function HeroSection() {
  return (
    <section
      className="light relative flex items-center overflow-hidden px-6"
      style={{ minHeight: `calc(100vh - ${MAIN_HEADER_HEIGHT}px)` }}
    >
      <img src={HERO_IMAGE} alt="" className="absolute inset-0 size-full object-cover object-center" />
      <div className="relative z-10 mx-auto w-full max-w-6xl py-16">
        <motion.div
          className="max-w-3xl"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <p className="mb-4 text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">
            Data Modelling Platform
          </p>
          <h1 className="text-4xl font-semibold tracking-tight text-foreground md:text-5xl">
            Interactive solutions for actuarial, risk and analytics work
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground">
            Apps, data and specialist teams in one platform — from onboarding to results.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-3">
            <Button size="lg" onClick={() => scrollToSection('get-in-touch')}>
              Get in touch
            </Button>
            <Button variant="outline" size="lg" onClick={() => scrollToSection('featured-apps')}>
              See apps
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
